import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { ArrowRotateRight, ArrowUpLong, Check, Clock, Cross, Download, EyeIcon, FileLines, Filter, Pause, PencilLine, Percent, RupeeSign, Search } from '../../../../../../../components/icons/Icons'
import { Col, Form, Row } from 'react-bootstrap'
import { AgGridReact } from "ag-grid-react";
import { Link, useNavigate } from 'react-router-dom';
import Widgets from "../../../../../../../components/Widgets/index"
import { toast } from "react-toastify";

import {
    getInitials,
    getInitialColor,
    currentFynencialYear,
    useSelect
} from "../../../../../../../services/commonServices";
import CustomPagination from "../../../../../../../components/CustomPagination";
import TdsDialoge from '../../../../../../../components/Dialog/tdsDialoge';
import { DepartmentList, RegimetList, FinancialYear, AllStatusList, BranchList, PageList } from "../../../../../../../components/FormElements/index.js";
import { useDispatch } from 'react-redux';
import {
    getEmployeePayrollRecordsPath,
    getTDSDashboardPath,
    getTDSRecentActivityPath,
    manageTDSFormsPath
} from '../../../../../../../services/config.js';
import {
    getTdsAllData,
    getTdsEmpListData,
    initAllTds,
    initTdsEmpList
} from '../../../../../../../redux/slices/tdsSlice.js';

const paginationPageSize = 10;
const paginationPageSizeSelector = [10, 20, 50, 100];

const Index = () => {
    useEffect(() => {
        localStorage.removeItem("tdsUser")
    }, [])

    const user = JSON.parse(localStorage.getItem("user_data") || "{}");

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const tdsStore = useSelect("tds")

    const [dashboardData, setDashboardData] = useState({
        summary: {
            totalTDSSubmitted: { count: "0", label: "Total TDS Submitted", trend: "+12% vs last month" },
            pendingVerifications: { count: 0, label: "Pending Verifications", priority: "normal", note: null },
            approved: { count: 0, label: "Approved", rate: 0, trend: "0% approval rate" },
            rejected: { count: 0, label: "Rejected", rate: 0, trend: "0% rejection rate" },
            avgProcessingTime: { days: 2.4, label: "Avg Processing Time", unit: "Days per submission" }
        },
        regimeDistribution: {
            oldRegime: { count: 0, percentage: 0 },
            newRegime: { count: 0, percentage: 0 }
        },
        deductionBreakdown: {
            houseRent: { amount: 0, percentage: 0 },
            lifeInsurance: { amount: 0, percentage: 0 },
            medicalInsurance: { amount: 0, percentage: 0 },
            educationLoan: { amount: 0, percentage: 0 },
            homeLoan: { amount: 0, percentage: 0 },
            others: { amount: 0, percentage: 0 }
        },
        panCompliance: {
            panPresent: { count: "0", percentage: 0, employees: "0 Employees" },
            panMissing: { count: "0", percentage: 0, employees: "0 Employees" }
        },
        processingTrends: [],
        metadata: {
            financialYear: "2025-26",
            totalEmployees: "0",
            lastUpdated: "",
            complianceRate: 0
        }
    })

    const [recentActivity, setRecentActivity] = useState([]);
    const [activityLoading, setActivityLoading] = useState(true);

    const [tdsEmpList, setTdsEmpList] = useState([])
    const [selectedRowsData, setSelectedRowsData] = useState([]);
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);
    const gridRef = useRef(null);
    const [gridApi, setGridApi] = useState(null);
    const [isApproved, setIsApproved] = useState(false)
    const [isRequestEdit, setIsRequestEdit] = useState(false)
    const [isHold, setIsHold] = useState(false)
    const [isRejected, setIsRejected] = useState(false)
    const [quickPresets, setQuickPresets] = useState("")
    const [staffId, setStaffId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [tableLoading, setTableLoading] = useState(true);
    const [isExporting, setIsExporting] = useState(false); // Add export loading state

    const [state, setState] = useState({
        financialYear: currentFynencialYear(),
        departmentId: "",
        regimeType: "",
        branchId: "",
        status: "",
        submissinFromDate: "",
        submissinToDate: "",
    })

    const onGridReady = (params) => {
        setGridApi(params.api);
    };

    useEffect(() => {
        const style = document.createElement('style');
        style.id = 'form12bb-checkbox-style';
        style.innerHTML = `
            .ag-theme-quartz input[type="checkbox"] {
                border-radius: 0 !important;
            }
            .ag-theme-quartz .ag-selection-checkbox,
            .ag-theme-quartz .ag-checkbox-input,
            .ag-theme-quartz .ag-icon-checkbox-checked,
            .ag-theme-quartz .ag-icon-checkbox-indeterminate {
                border-radius: 0 !important;
            }
        `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, []);


    useEffect(() => {
        const onDocClick = (e) => {
            if (!rootRef.current) return;
            if (!rootRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        const onEsc = (e) => {
            if (e.key === "Escape") setOpen(false);
        };

        if (open) {
            document.addEventListener("mousedown", onDocClick);
            document.addEventListener("touchstart", onDocClick);
            document.addEventListener("keydown", onEsc);
        } else {
            document.removeEventListener("mousedown", onDocClick);
            document.removeEventListener("touchstart", onDocClick);
            document.removeEventListener("keydown", onEsc);
        }

        return () => {
            document.removeEventListener("mousedown", onDocClick);
            document.removeEventListener("touchstart", onDocClick);
            document.removeEventListener("keydown", onEsc);
        };
    }, [open]);

    const onSelectionChanged = useCallback(() => {
        const selectedNodes = gridRef.current?.api?.getSelectedNodes();
        const selectedData = selectedNodes?.map((node) => node.data) || [];
        setSelectedRowsData(selectedData);
    }, []);

    const navigateToReviewQue = (employeeData) => {
        localStorage.setItem("tdsUser", JSON.stringify(employeeData));
        navigate("/payroll/tds/review");
        toast.success(`Opening review for: ${employeeData.employeeName || 'Employee'}`);
    }

    // ==================== EXPORT FUNCTIONALITY ====================
    
    // Convert data to CSV format
    const convertToCSV = (data) => {
        if (!data || data.length === 0) {
            return null;
        }

        // Define CSV headers
        const headers = [
            'Employee ID',
            'Employee Name',
            'Job Title',
            'PAN Number',
            'Financial Year',
            'Status',
            'Declared Deductions',
            'Taxable Income',
            'TDS Per Month',
            'Proof Status',
            'Last Action',
            'Last Action Date'
        ];

        // Map data to CSV rows
        const rows = data.map(employee => {
            return [
                employee.employeeId || employee.id || employee.staffId || '-',
                employee.employeeName || '-',
                employee.jobTitle || '-',
                employee.panNumber || '-',
                employee.financialYear || state.financialYear || '-',
                employee.status || 'pending',
                employee.deductions || '0',
                employee.taxableIncome || '0',
                employee.tdsPerMonth || '0',
                employee.proofStatus || 'Not Uploaded',
                employee.lastAction || '-',
                employee.lastActionDate || '-'
            ];
        });

        // Escape CSV values (handle commas, quotes, newlines)
        const escapeCSV = (value) => {
            if (value === null || value === undefined) return '';
            const stringValue = String(value);
            // If value contains comma, quote, or newline, wrap in quotes and escape internal quotes
            if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
                return `"${stringValue.replace(/"/g, '""')}"`;
            }
            return stringValue;
        };

        // Build CSV string
        const csvContent = [
            headers.map(escapeCSV).join(','),
            ...rows.map(row => row.map(escapeCSV).join(','))
        ].join('\n');

        return csvContent;
    };

    // Download CSV file
    const downloadCSV = (csvContent, filename) => {
        // Add BOM for Excel to recognize UTF-8
        const BOM = '\uFEFF';
        const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
        
        // Create download link
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Cleanup
        URL.revokeObjectURL(url);
    };

    // Main export handler
    const handleExport = useCallback((exportType = 'csv') => {
        setIsExporting(true);
        
        try {
            // Determine what data to export (selected or all)
            const dataToExport = selectedRowsData.length > 0 ? selectedRowsData : tdsEmpList;
            
            if (!dataToExport || dataToExport.length === 0) {
                toast.warning("No data available to export");
                setIsExporting(false);
                return;
            }

            // Generate filename with date and financial year
            const currentDate = new Date().toISOString().split('T')[0];
            const fyForFilename = state.financialYear.replace('-', '_');
            const exportScope = selectedRowsData.length > 0 ? 'selected' : 'all';
            const filename = `TDS_Form12BB_${exportScope}_FY${fyForFilename}_${currentDate}.csv`;

            if (exportType === 'csv') {
                const csvContent = convertToCSV(dataToExport);
                
                if (!csvContent) {
                    toast.error("Failed to generate export data");
                    setIsExporting(false);
                    return;
                }

                downloadCSV(csvContent, filename);
                
                toast.success(
                    `Successfully exported ${dataToExport.length} record(s)`,
                    { autoClose: 3000 }
                );
            } else if (exportType === 'excel') {
                // For Excel export, you can use a library like xlsx
                handleExcelExport(dataToExport, filename.replace('.csv', '.xlsx'));
            }
            
        } catch (error) {
            console.error("Export error:", error);
            toast.error("Export failed. Please try again.");
        } finally {
            setIsExporting(false);
        }
    }, [selectedRowsData, tdsEmpList, state.financialYear]);

    // Excel export handler (optional - requires xlsx library)
    const handleExcelExport = (data, filename) => {
        try {
            // Check if xlsx library is available
            // If you want Excel support, install: npm install xlsx
            // import * as XLSX from 'xlsx';
            
            // For now, fallback to CSV
            toast.info("Excel export not configured. Exporting as CSV instead.");
            handleExport('csv');
            
            /* 
            // Uncomment this if you have xlsx library installed:
            const worksheet = XLSX.utils.json_to_sheet(data.map(employee => ({
                'Employee ID': employee.staffId || employee.id || employee.employeeId || '-',
                'Employee Name': employee.employeeName || '-',
                'Job Title': employee.jobTitle || '-',
                'PAN Number': employee.panNumber || '-',
                'Financial Year': employee.financialYear || state.financialYear || '-',
                'Status': employee.status || 'pending',
                'Declared Deductions': employee.deductions || '0',
                'Taxable Income': employee.taxableIncome || '0',
                'TDS Per Month': employee.tdsPerMonth || '0',
                'Proof Status': employee.proofStatus || 'Not Uploaded',
                'Last Action': employee.lastAction || '-',
                'Last Action Date': employee.lastActionDate || '-'
            })));
            
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'TDS Data');
            XLSX.writeFile(workbook, filename);
            
            toast.success(`Successfully exported ${data.length} record(s) to Excel`);
            */
        } catch (error) {
            console.error("Excel export error:", error);
            toast.error("Excel export failed");
        }
    };

    // Export using AG Grid built-in functionality (alternative method)
    const handleGridExport = useCallback(() => {
        if (!gridRef.current?.api) {
            toast.error("Grid not ready for export");
            return;
        }

        setIsExporting(true);

        try {
            const currentDate = new Date().toISOString().split('T')[0];
            const fyForFilename = state.financialYear.replace('-', '_');
            
            // Use AG Grid's built-in export
            gridRef.current.api.exportDataAsCsv({
                fileName: `TDS_Form12BB_FY${fyForFilename}_${currentDate}.csv`,
                onlySelected: selectedRowsData.length > 0,
                columnKeys: [
                    'staffId', 'employeeName', 'jobTitle', 'panNumber', 
                    'financialYear', 'status', 'deductions', 'taxableIncome',
                    'tdsPerMonth', 'proofStatus', 'lastAction', 'lastActionDate'
                ],
                processCellCallback: (params) => {
                    // Process cell values for export
                    if (params.value === null || params.value === undefined) {
                        return '-';
                    }
                    return params.value;
                },
                processHeaderCallback: (params) => {
                    // Custom header names
                    const headerMap = {
                        'staffId': 'Employee ID',
                        'employeeName': 'Employee Name',
                        'jobTitle': 'Job Title',
                        'panNumber': 'PAN Number',
                        'financialYear': 'Financial Year',
                        'status': 'Status',
                        'deductions': 'Declared Deductions',
                        'taxableIncome': 'Taxable Income',
                        'tdsPerMonth': 'TDS Per Month',
                        'proofStatus': 'Proof Status',
                        'lastAction': 'Last Action',
                        'lastActionDate': 'Last Action Date'
                    };
                    return headerMap[params.column.getColId()] || params.column.getColId();
                }
            });

            const exportCount = selectedRowsData.length > 0 ? selectedRowsData.length : tdsEmpList.length;
            toast.success(`Successfully exported ${exportCount} record(s)`);
            
        } catch (error) {
            console.error("Grid export error:", error);
            toast.error("Export failed. Please try again.");
        } finally {
            setIsExporting(false);
        }
    }, [selectedRowsData, tdsEmpList, state.financialYear]);

    // ==================== END EXPORT FUNCTIONALITY ====================

    // Function to update ONLY proof status and last action after bulk actions
    const updateLocalEmployeeProofStatus = (staffIds, actionType) => {
        const proofStatusMap = {
            "approve": { proofStatus: "Verified", lastAction: "Approved" },
            "reject": { proofStatus: "Rejected", lastAction: "Rejected" },
            "hold": { proofStatus: "On Hold", lastAction: "Put on Hold" },
            "request_edit": { proofStatus: "Edit Requested", lastAction: "Edit Requested" }
        };
        
        const { proofStatus: newProofStatus, lastAction } = proofStatusMap[actionType] || { 
            proofStatus: "Pending", 
            lastAction: "Updated" 
        };
        
        // Update tdsEmpList state - ONLY proofStatus and lastAction
        setTdsEmpList(prevList => 
            prevList.map(employee => {
                const employeeId = employee.id || employee.staffId || employee.employeeId;
                if (staffIds.includes(employeeId)) {
                    return {
                        ...employee,
                        // ❌ Status remains UNCHANGED - only proofStatus updates
                        proofStatus: newProofStatus,
                        lastAction: lastAction,
                        lastActionDate: new Date().toLocaleDateString('en-IN', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                        })
                    };
                }
                return employee;
            })
        );
        
        // Refresh grid
        if (gridRef.current?.api) {
            setTimeout(() => {
                gridRef.current.api.refreshCells({ force: true });
                gridRef.current.api.redrawRows();
            }, 100);
        }
        
        console.log(`Updated proof status for ${staffIds.length} employees: ${newProofStatus}`);
    };

    // Bulk Action Handler
    const handleBulkAction = async (actionType, selectedData = selectedRowsData) => {
        let selectedItems = selectedData.length > 0 ? selectedData : staffId ? [{ employeeId: staffId }] : [];

        if (selectedItems.length === 0) {
            toast.warning("Please select at least one employee");
            return;
        }

        // Extract user_id safely
        const userData = JSON.parse(localStorage.getItem("user_data") || "{}");
        const currentUserId = Number(userData.user_id || userData.id || userData.userId || 0);

        if (!currentUserId || currentUserId === 0) {
            toast.error("User session invalid. Please log in again.");
            console.error("Missing or invalid user_id in localStorage:", userData);
            return;
        }

        // Extract employee IDs first, fallback to numeric IDs
        const staffIds = selectedItems
            .map(row => row.employeeId || row.id || row.staffId)
            .filter(id => id != null && id !== '')
            .map(id => id);

        if (staffIds.length === 0) {
            toast.error("No valid staff IDs found");
            return;
        }

        // Map action to backend status
        const statusMap = {
            "approve": "approved",
            "reject": "rejected",
            "hold": "hold",
            "request_edit": "revision"
        };

        const status = statusMap[actionType] || actionType;

        const payload = {
            user_id: currentUserId,
            staff_ids: staffIds,
            status: status,
            financial_year: state.financialYear,
            remarks: quickPresets || "No remarks"
        };

        console.log("Sending payload to API:", payload);

        try {
            const response = await fetch(manageTDSFormsPath, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
                },
                body: JSON.stringify(payload)
            });

            const result = await response.json();
            console.log("API Response:", result);

            if (response.ok && result.code === 200) {
                const processed = result.data?.processedCount || 0;
                const errors = result.data?.errors || [];

                if (processed > 0) {
                    toast.success(`Successfully processed ${processed} form(s)`);
                    
                    // ✅ Update ONLY proof status (not main status)
                    updateLocalEmployeeProofStatus(staffIds, actionType);
                } else {
                    toast.warning(result.message || "No forms were processed");
                }

                errors.forEach(err => toast.info(err));

                // Refresh dashboard data
                getAllTdsData();
                
                if (gridRef.current?.api) gridRef.current.api.deselectAll();
            } else {
                const msg = result.message || "Validation failed";
                const errors = result.errors ? Object.values(result.errors).flat().join("; ") : "";
                toast.error(errors ? `${msg}: ${errors}` : msg);
            }
        } catch (err) {
            console.error("Network error:", err);
            toast.error("Network error. Please try again.");
        }

        // Reset dialogs
        setIsApproved(false);
        setIsRequestEdit(false);
        setIsHold(false);
        setIsRejected(false);
        setQuickPresets("");
        setStaffId(null);
    };

    const closeApproveDialog = () => setIsApproved(false);
    const submitApproveForm = () => handleBulkAction("approve");

    const closeRequestEditDialog = () => setIsRequestEdit(false);
    const submitRequestEditForm = () => handleBulkAction("request_edit");

    const closeHoldDialog = () => setIsHold(false);
    const submitHoldForm = () => handleBulkAction("hold");

    const closeRejectDialog = () => setIsRejected(false);
    const submitRejectForm = () => handleBulkAction("reject");

    const columnDefs = useMemo(
        () => [
            {
                headerName: "",
                field: "checkbox",
                checkboxSelection: true,
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: false,
                width: 70,
                minWidth: 70,
                maxWidth: 70,
                pinned: "left",
                suppressMenu: true,
                suppressSorting: true,
                suppressHideColumn: true,
                cellStyle: { 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    padding: "0px",
                    margin: "0 auto",
                    height: "100%",
                    width: "100%"
                },
                headerClass: "ag-center-aligned-header",
                cellClass: "ag-center-aligned"
            },
            {
                headerName: "Employee ID & Name",
                field: "employeeId",
                pinned: "left",
                width: 300,
                sortable: true,
                filter: true,
                suppressRowClickSelection: true,
                cellRenderer: (params) => {
                    const employeeId = params.data.employeeId || params.data.id || params.data.staffId || "-";
                    const employeeName = params.data.employeeName || "";
                    const jobTitle = params.data.jobTitle || "-";

                    return (
                        <div style={{ 
                            display: "flex", 
                            alignItems: "center", 
                            gap: "12px",
                            cursor: "pointer",
                            height: "100%",
                            width: "100%",
                            padding: "8px 0"
                        }}
                        onClick={() => params.context?.onStaffClick?.(params.data)}
                        >
                            {/* Avatar Circle */}
                            <div style={{
                                width: "36px",
                                height: "36px",
                                borderRadius: "50%",
                                overflow: "hidden",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: getInitialColor(employeeName),
                                color: "white",
                                fontWeight: "bold",
                                fontSize: "14px",
                                flexShrink: 0,
                                textTransform: "uppercase"
                            }}>
                                {getInitials(employeeName)}
                            </div>

                            {/* ID and Staff Info Container */}
                            <div style={{ 
                                display: "flex", 
                                flexDirection: "column",
                                lineHeight: "1.3",
                                gap: "2px",
                                flex: 1,
                                minWidth: 0
                            }}>
                                <span 
                                    style={{
                                        fontSize: "12px",
                                        color: "#a0a0a0",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }}
                                >
                                    {employeeId}
                                </span>
                                <span 
                                    className="font-weight-400 link-hover"
                                    style={{
                                        fontSize: "14px",
                                        color: "#ffffff",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }}
                                >
                                    {employeeName || "-"}
                                </span>
                                <span 
                                    className="color-gray font-weight-200 font-12"
                                    style={{
                                        fontSize: "12px",
                                        color: "#a0a0a0",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }}
                                >
                                    {jobTitle}
                                </span>
                            </div>
                        </div>
                    );
                },
            },
            {
                headerName: "Department",
                field: "department",
                width: "150px",
                sortable: true,
                filter: true,
                cellRenderer: (params) => <span>{params.data.department || "-"}</span>,
            },
            {
                headerName: "PAN",
                field: "panNumber", // Add field for export
                width: "120px",
                cellRenderer: (params) => <span>{params.data.panNumber || "-"}</span>,
            },
            {
                headerName: "FY",
                field: "financialYear", // Add field for export
                width: "80px",
                cellRenderer: (params) => <span>{params.data.financialYear || state.financialYear || "-"}</span>,
            },
            {
                headerName: "Status",
                field: "status", // Add field for export
                width: "120px",
                cellRenderer: (params) => {
                    const statusText = params.data.statusText || params.data.status || "pending";
                    const normalized = String(params.data.statusColor || params.data.status || statusText).toLowerCase();
                    const statusClass = normalized.includes("approved")
                        ? "badge-green"
                        : normalized.includes("rejected")
                        ? "badge-red"
                        : normalized.includes("hold")
                        ? "badge-orange"
                        : normalized.includes("revision")
                        ? "badge-orange"
                        : normalized.includes("pending")
                        ? "badge-yellow"
                        : "badge-gray";
                    return (
                        <span className={`status-chip ${statusClass}`}>{statusText}</span>
                    );
                },
            },
            {
                headerName: "Declared Deductions",
                field: "deductions", // Add field for export
                width: "150px",
                cellRenderer: (params) => <span className="font-weight-500">₹{params.data.deductions || "0"}</span>,
            },
            {
                headerName: "Taxable Income",
                field: "taxableIncome", // Add field for export
                width: "130px",
                cellRenderer: (params) => <span className="font-weight-500">₹{params.data.taxableIncome || "0"}</span>,
            },
            {
                headerName: "TDS/month",
                field: "tdsPerMonth", // Add field for export
                width: "120px",
                cellRenderer: (params) => <span className="font-weight-500">₹{params.data.tdsPerMonth || "0"}</span>,
            },
            {
                headerName: "Proof Status",
                field: "proofStatus", // Add field for export
                width: "120px",
                cellRenderer: (params) => {
                    const proofStatusText = params.data.proofStatusText || params.data.proofStatus || "Not Uploaded";
                    const normalizedProof = String(params.data.proofStatusColor || params.data.proofStatus || proofStatusText).toLowerCase();
                    const proofClass = normalizedProof.includes("verified")
                        ? "badge-green"
                        : normalizedProof.includes("rejected")
                        ? "badge-red"
                        : normalizedProof.includes("pending") || normalizedProof.includes("on hold")
                        ? "badge-yellow"
                        : normalizedProof.includes("edit requested")
                        ? "badge-orange"
                        : "badge-gray";
                    return <span className={`proof-chip ${proofClass} font-12`}>{proofStatusText}</span>;
                },
            },
            {
                headerName: "Last Action",
                field: "lastAction", // Add field for export
                width: "150px",
                cellRenderer: (params) => {
                    const lastAction = params.data.lastAction || "-";
                    const lastActionDate = params.data.lastActionDate || "";
                    if (lastAction === "-") return <span>-</span>;
                    return (
                        <div className="d-flex flex-column">
                            <span className="font-12">{lastAction}</span>
                            {lastActionDate && <span className="color-gray font-10">{lastActionDate}</span>}
                        </div>
                    );
                },
            },
            {
                headerName: "Actions",
                pinned: "right",
                width: "300px",
                cellRenderer: (params) => {
                    const employeeData = params.data;
                    const rowId = employeeData.employeeId || employeeData.id || employeeData.staffId;

                    return (
                        <div className='d-flex align-items-center gap-2'>
                            <button className='purple-icon-container cursor-pointer p-2 border-0 bg-transparent' onClick={() => navigateToReviewQue(employeeData)} title="Quick Review"><EyeIcon /></button>
                            <button className='green-icon-container cursor-pointer p-2 border-0 bg-transparent' onClick={() => { 
                                setStaffId(rowId); 
                                setIsApproved(true);
                            }} title="Approve"><Check /></button>
                            <button className='yellow-icon-container cursor-pointer p-2 border-0 bg-transparent' onClick={() => { 
                                setStaffId(rowId); 
                                setIsRequestEdit(true);
                            }} title="Request Edit"><PencilLine /></button>
                            <button className='orange-icon-container cursor-pointer p-2 border-0 bg-transparent' onClick={() => { 
                                setStaffId(rowId); 
                                setIsHold(true);
                            }} title="Put on Hold"><Pause /></button>
                            <button className='red-icon-container cursor-pointer p-2 border-0 bg-transparent' onClick={() => { 
                                setStaffId(rowId); 
                                setIsRejected(true);
                            }} title="Reject"><Cross /></button>
                        </div>
                    );
                },
                suppressRowClickSelection: true,
                sortable: false,
                filter: false,
            },
        ],
        [state.financialYear, navigateToReviewQue]
    );

    const handleInputChange = ({ target: { name, value } }) => {
        setState((pre) => ({ ...pre, [name]: value }));
    };

    const setSelectedYear = (value) => {
        setState((pre) => ({ ...pre, financialYear: value }));
    };

    const clearAllFilter = () => {
        setState({
            financialYear: currentFynencialYear(),
            departmentId: "",
            regimeType: "",
            branchId: "",
            status: "",
            submissinFromDate: "",
            submissinToDate: "",
        });
        toast.success("Filters cleared");
    };

    const applyFilters = () => {
        getTdsEmpPayrollData();
        toast.success("Filters applied");
    };

    const getAllTdsData = useCallback(() => {
        setLoading(true);
        const userId = user.user_id || user.userId || user.id || null;
        dispatch(getTdsAllData({
            path: getTDSDashboardPath,
            data: {
                userId,
                financialYear: state.financialYear,
                departmentId: state.departmentId || null,
                regimeType: state.regimeType === "old" ? null : (state.regimeType || null),
                branchId: state.branchId || null,
            }
        }));
    }, [dispatch, user.user_id, user.userId, user.id, state]);

    const getTdsEmpPayrollData = useCallback(() => {
        setTableLoading(true);
        dispatch(getTdsEmpListData({
            path: getEmployeePayrollRecordsPath,
            data: {
                userId: user.user_id,
                financialYear: state.financialYear,
                departmentId: state.departmentId || null,
                regimeType: state.regimeType || null,
                branchId: state.branchId || null,
                status: state.status || null,
                fromDate: state.submissinFromDate || null,
                toDate: state.submissinToDate || null,
            }
        }));
    }, [dispatch, user.user_id, state]);
    
const [error, setError] = useState(null);
const getRecentActivity = useCallback(async () => {
    setActivityLoading(true);
    setError(null); // Clear any previous errors
    
    try {
        // Enhanced token debugging
        console.log("🔍 Debug - Fetching recent activity...");
        console.log("📁 Available localStorage keys:", Object.keys(localStorage));
        
        const token = localStorage.getItem('token');
        console.log("🔑 Token retrieved (first 20 chars):", token ? `${token.substring(0, 20)}...` : 'NULL/UNDEFINED');
        console.log("👤 User ID:", user?.user_id);
        console.log("📅 Financial Year:", state.financialYear);
        
        if (!token || token === 'null' || token === 'undefined' || token.trim() === '') {
            console.error("❌ Authentication token is invalid or missing!");
            console.error("💡 Check if token is being saved properly in localStorage");
            console.error("💡 Check authentication flow and token expiration");
            
            // Optional: Show user-friendly error
            setError({
                type: 'AUTH_ERROR',
                message: 'Authentication required. Please log in again.',
                details: 'Token not found in browser storage'
            });
            
            setActivityLoading(false);
            
            // Optional: Trigger re-authentication
            // handleAuthRedirect();
            return;
        }

        // Token validation - basic format check
        if (token.length < 10) {
            console.warn("⚠️ Token appears to be too short:", token.length, "characters");
        }

        const response = await fetch(getTDSRecentActivityPath, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                user_id: user.user_id,
                financial_year: state.financialYear
            })
        });

        console.log("🌐 API Response Status:", response.status, response.statusText);
        
        if (!response.ok) {
            // Handle specific HTTP errors
            if (response.status === 401) {
                console.error("🔒 Unauthorized (401): Token might be expired or invalid");
                setError({
                    type: 'UNAUTHORIZED',
                    message: 'Your session has expired. Please log in again.',
                    details: `HTTP ${response.status} - ${response.statusText}`
                });
                
                // Clear invalid token
                localStorage.removeItem('token');
                
                // Optional: Redirect to login
                // window.location.href = '/login';
            } else if (response.status === 403) {
                console.error("🚫 Forbidden (403): Insufficient permissions");
                setError({
                    type: 'FORBIDDEN',
                    message: 'You do not have permission to view recent activity.',
                    details: `HTTP ${response.status}`
                });
            } else {
                console.error("⚠️ Recent activity API error:", response.status, response.statusText);
                setError({
                    type: 'API_ERROR',
                    message: 'Failed to load recent activity.',
                    details: `HTTP ${response.status} - ${response.statusText}`
                });
            }
            
            setActivityLoading(false);
            return;
        }

        const result = await response.json();
        console.log("📊 Recent Activity API Response:", {
            code: result.code,
            status: result.status,
            message: result.message,
            activitiesCount: result.data?.activities?.length || 0
        });

        // Check if API returned success with empty activities
        if (result.code === 200 && result.status === true) {
            if (result.data?.activities && Array.isArray(result.data.activities)) {
                if (result.data.activities.length > 0) {
                    console.log(`✅ Loaded ${result.data.activities.length} activity items`);
                    setRecentActivity(result.data.activities);
                    setError(null); // Clear any previous errors
                } else {
                    // Empty activities array - no recent activity
                    console.log("ℹ️ No recent activity data found");
                    setRecentActivity([]);
                    setError({
                        type: 'NO_DATA',
                        message: 'No recent activity found.',
                        details: 'The account has no recent transactions or activities for the selected period.'
                    });
                }
            } else {
                // Invalid data structure
                console.warn("⚠️ Invalid activities data structure:", result.data);
                setRecentActivity([]);
                setError({
                    type: 'INVALID_DATA',
                    message: 'Received invalid data format.',
                    details: 'Activities data is not in expected format'
                });
            }
        } else {
            console.warn("⚠️ API returned non-success status:", result.message);
            setRecentActivity([]);
            setError({
                type: 'API_WARNING',
                message: result.message || 'API request completed with warnings.',
                details: `Code: ${result.code}, Status: ${result.status}`
            });
        }
    } catch (error) {
        console.error("❌ Recent activity fetch error:", error);
        setRecentActivity([]);
        setError({
            type: 'NETWORK_ERROR',
            message: 'Network error occurred.',
            details: error.message
        });
    } finally {
        setActivityLoading(false);
        console.log("🏁 Recent activity fetch completed");
    }
}, [user.user_id, state.financialYear]);

    useEffect(() => {
        getAllTdsData();
        getTdsEmpPayrollData();
        getRecentActivity();
    }, [getAllTdsData, getTdsEmpPayrollData, getRecentActivity]);

    useEffect(() => {
        if (tdsStore.tdsAllSuccess && tdsStore.tdsAllData) {
            const apiResponse = tdsStore.tdsAllData;
            let apiData = apiResponse;

            if (apiResponse.data) {
                apiData = apiResponse.data;
            }

            if (apiData.summary) {
                setDashboardData(prev => ({
                    ...prev,
                    summary: {
                        totalTDSSubmitted: {
                            count: Number(apiData.summary.totalTDSSubmitted) || 0,
                            label: "Total TDS Submitted",
                            trend: apiData.summary.totalTDSTrend || "+0% vs last month"
                        },
                        pendingVerifications: {
                            count: Number(apiData.summary.pendingVerifications) || 0,
                            label: "Pending Verifications",
                            priority: apiData.summary.pendingVerifications > 0 ? "high" : "normal",
                            note: null
                        },
                        approved: {
                            count: Number(apiData.summary.approved) || 0,
                            label: "Approved",
                            rate: apiData.summary.approvedRate || "0%",
                            trend: apiData.summary.approvedRate || "0% approval rate"
                        },
                        rejected: {
                            count: Number(apiData.summary.rejected) || 0,
                            label: "Rejected",
                            rate: apiData.summary.rejectedRate || "0%",
                            trend: apiData.summary.rejectedRate || "0% rejection rate"
                        },
                        avgProcessingTime: {
                            days: Number(apiData.summary.avgProcessingTime) || 0,
                            label: "Avg Processing Time",
                            unit: "Days per submission"
                        }
                    },
                    regimeDistribution: apiData.slabWiseDistribution || prev.regimeDistribution,
                    deductionBreakdown: apiData.deductionBreakdown || prev.deductionBreakdown,
                    panCompliance: apiData.panCompliance || prev.panCompliance,
                    processingTrends: apiData.processingTrends || prev.processingTrends,
                    metadata: apiData.metadata || prev.metadata
                }));
                setLoading(false);
            }
            dispatch(initAllTds());
        }

        if (tdsStore.tdsAllError) {
            toast.error(tdsStore.tdsAllError || "Failed to load dashboard data");
            setLoading(false);
            dispatch(initAllTds());
        }

        if (tdsStore.tdsEmpListSuccess) {
            const payload = tdsStore.tdsEmpListData;
            const employees = Array.isArray(payload)
                ? payload
                : (payload?.employeeList?.employees || payload?.employees || payload?.data?.employeeList?.employees || []);
            setTdsEmpList(employees || []);
            setTableLoading(false);
            dispatch(initTdsEmpList());
        }

        if (tdsStore.tdsEmpListError) {
            toast.error(tdsStore.tdsEmpListError || "Failed to load employee list");
            setTableLoading(false);
            dispatch(initTdsEmpList());
        }
    }, [tdsStore, dispatch]);

    const getCurrentFY = () => {
        const year = parseInt(state.financialYear || currentFynencialYear());
        return `${year}-${year + 1}`;
    };

    const selectedCount = selectedRowsData.length;

    return (
        <div>
            <div>
                <h3 className='color-white font-weight-200 mb-2'>TDS Form 12BB Approvals</h3>
                <h4 className='color-gray font-14 font-weight-200'>
                    Review and approve employee tax declaration submissions for FY {getCurrentFY()}
                </h4>
            </div>

            {loading ? (
                <div className="text-center py-5">
                    <div className="spinner-border text-purple" style={{ width: '3rem', height: '3rem' }} />
                    {/* <p className="mt-2 color-gray">Loading dashboard data...</p> */}
                </div>
            ) : (
                <div style={{ margin: '30px 0', padding: '0 20px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'stretch', gap: '16px', flexWrap: 'wrap' }}>
                        {/* Card 1: Total TDS Submitted */}
                        <div className='form12bb-card setting-border' style={{ flex: '1 1 180px', minWidth: '180px', maxWidth: '220px', padding: '16px 20px', height: '140px' }}>
                            <h4 className='color-gray font-weight-200 font-13 mb-2'>{dashboardData.summary.totalTDSSubmitted.label}</h4>
                            <div className='d-flex align-items-center justify-content-between gap-3 mb-2'>
                                <h3 className='color-white font-26 font-weight-300 mb-0'>{dashboardData.summary.totalTDSSubmitted.count}</h3>
                                <span className='blue-icon-container' style={{ width: '40px', height: '40px', fontSize: '20px' }}>
                                    <FileLines />
                                </span>
                            </div>
                            <div className='d-flex align-items-center gap-2 text-purple font-weight-200 font-12'>
                                <ArrowUpLong style={{ fontSize: '14px' }} /> {dashboardData.summary.totalTDSSubmitted.trend}
                            </div>
                        </div>

                        {/* Card 2: Pending Verification */}
                        <div className='form12bb-card setting-border' style={{ flex: '1 1 180px', minWidth: '180px', maxWidth: '220px', padding: '16px 20px', height: '140px' }}>
                            <h4 className='color-gray font-weight-200 font-13 mb-2'>{dashboardData.summary.pendingVerifications.label}</h4>
                            <div className='d-flex align-items-center justify-content-between gap-3 mb-2'>
                                <h3 className='color-white font-26 font-weight-300 mb-0'>{dashboardData.summary.pendingVerifications.count}</h3>
                                <span className='yellow-icon-container' style={{ width: '40px', height: '40px', fontSize: '20px' }}>
                                    <Clock />
                                </span>
                            </div>
                            <div className={`d-flex align-items-center gap-2 font-weight-200 font-12 ${dashboardData.summary.pendingVerifications.priority === "high" ? "text-red" : "yellow-text"}`}>
                                {dashboardData.summary.pendingVerifications.priority === "high" ? "⚠ High priority" : "Normal priority"}
                            </div>
                        </div>

                        {/* Card 3: Approved */}
                        <div className='form12bb-card setting-border' style={{ flex: '1 1 180px', minWidth: '180px', maxWidth: '220px', padding: '16px 20px', height: '140px' }}>
                            <h4 className='color-gray font-weight-200 font-13 mb-2'>{dashboardData.summary.approved.label}</h4>
                            <div className='d-flex align-items-center justify-content-between gap-3 mb-2'>
                                <h3 className='color-white font-26 font-weight-300 mb-0'>{dashboardData.summary.approved.count}</h3>
                                <span className='purple-icon-container' style={{ width: '40px', height: '40px', fontSize: '20px' }}>
                                    <Check />
                                </span>
                            </div>
                            <div className='d-flex align-items-center gap-2 text-purple font-weight-200 font-12'>
                                ✓ {dashboardData.summary.approved.trend}
                            </div>
                        </div>

                        {/* Card 4: Rejected */}
                        <div className='form12bb-card setting-border' style={{ flex: '1 1 180px', minWidth: '180px', maxWidth: '220px', padding: '16px 20px', height: '140px' }}>
                            <h4 className='color-gray font-weight-200 font-13 mb-2'>{dashboardData.summary.rejected.label}</h4>
                            <div className='d-flex align-items-center justify-content-between gap-3 mb-2'>
                                <h3 className='color-white font-26 font-weight-300 mb-0'>{dashboardData.summary.rejected.count}</h3>
                                <span className='red-icon-container' style={{ width: '40px', height: '40px', fontSize: '20px' }}>
                                    <Cross />
                                </span>
                            </div>
                            <div className='d-flex align-items-center gap-2 text-red font-weight-200 font-12'>
                                × {dashboardData.summary.rejected.trend}
                            </div>
                        </div>

                        {/* Card 5: Avg Processing Time */}
                        <div className='form12bb-card setting-border' style={{ flex: '1 1 180px', minWidth: '180px', maxWidth: '220px', padding: '16px 20px', height: '140px' }}>
                            <h4 className='color-gray font-weight-200 font-13 mb-2'>{dashboardData.summary.avgProcessingTime.label}</h4>
                            <div className='d-flex align-items-center justify-content-between gap-3 mb-2'>
                                <h3 className='color-white font-26 font-weight-300 mb-0'>{dashboardData.summary.avgProcessingTime.days}</h3>
                                <span className='info-icon-container' style={{ width: '40px', height: '40px', fontSize: '20px' }}>
                                    <Clock />
                                </span>
                            </div>
                            <div className='d-flex align-items-center gap-2 blue-text font-weight-200 font-12'>
                                {dashboardData.summary.avgProcessingTime.unit}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Filters Section */}
            <div className='setting-border height-auto mb-4 p-4'>
                <div className='d-flex align-items-center gap-3 mb-4 flex-wrap'>
                    <div className='relative'>
                        <Search class_name={"search-icon-absolute color-gray"} />
                        <Form.Control
                            placeholder='Search by Name, ID, or PAN...'
                            className='universal-input padding-left-30 border-radius-8px'
                            style={{ width: "300px" }}
                        />
                    </div>

                    <AllStatusList name="status" value={state.status} onChange={handleInputChange} />
                    <FinancialYear selectedYear={state.financialYear} setSelectedYear={setSelectedYear} />
                    <DepartmentList name={"departmentId"} value={state.departmentId} onChange={handleInputChange} />
                    <BranchList name="branchId" value={state.branchId} onChange={handleInputChange} />
                    <RegimetList name="regimeType" value={state.regimeType} onChange={handleInputChange} />
                </div>

                <div className='d-flex align-items-center justify-content-between gap-3 flex-wrap'>
                    <div className='d-flex align-items-center gap-3 flex-wrap'>
                        <span className='color-gray font-weight-200'>Submission Date: </span>
                        <Form.Control name='submissinFromDate' type='date' value={state.submissinFromDate} onChange={handleInputChange} className='universal-input border-radius-8px' style={{ width: "150px" }} />
                        <span className='color-gray font-weight-200'>to</span>
                        <Form.Control type='date' name='submissinToDate' value={state.submissinToDate} onChange={handleInputChange} className='universal-input border-radius-8px' style={{ width: "150px" }} />
                        <button className='universal-btn border-radius-8px d-flex align-items-center justify-content-center gap-2' style={{ height: "38px" }} onClick={applyFilters}>
                            <Filter /> Apply Filter
                        </button>

                        {(state.submissinFromDate || state.submissinToDate || state.financialYear !== currentFynencialYear() || state.departmentId || state.regimeType || state.status || state.branchId) && (
                            <button style={{ height: "35px" }} className="border-radius-8px d-flex align-items-center gap-2 universal-sec-btn" onClick={clearAllFilter}>
                                <Cross /> Clear
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {/* Selection Actions Bar */}
            <div className='setting-border height-auto d-flex align-items-center justify-content-between gap-2 mb-4 p-4'>
                <div className='d-flex align-items-center gap-2'>
                    <input
                        type="checkbox"
                        checked={selectedCount > 0 && selectedCount === tdsEmpList.length}
                        onChange={(e) => {
                            if (gridRef.current?.api) {
                                e.target.checked ? gridRef.current.api.selectAll() : gridRef.current.api.deselectAll();
                            }
                        }}
                        style={{ margin: 0, verticalAlign: "middle", width: 16, height: 16 }}
                    />
                    <span className='color-white font-weight-200 font-14'>Select All ({tdsEmpList.length} items)</span>
                    <span className='color-white font-weight-200 font-14'>|</span>
                    <span className='text-purple'>{selectedCount} selected</span>
                </div>
                <div className='d-flex align-items-center gap-2'>
                    <button className='d-flex align-items-center justify-content-center gap-2 universal-btn' onClick={() => setIsApproved(true)} disabled={selectedCount === 0}>
                        <Check /> Approve Selected
                    </button>
                    <button className='d-flex align-items-center justify-content-center gap-2 universal-btn-yellow' onClick={() => setIsRequestEdit(true)} disabled={selectedCount === 0}>
                        <PencilLine /> Request Edit
                    </button>
                    <button className='d-flex align-items-center justify-content-center gap-2 universal-btn-orange' onClick={() => setIsHold(true)} disabled={selectedCount === 0}>
                        <Pause /> Put On Hold
                    </button>
                    <button className='d-flex align-items-center justify-content-center gap-2 universal-btn-red' onClick={() => setIsRejected(true)} disabled={selectedCount === 0}>
                        <Cross /> Reject
                    </button>
                    
                    {/* ✅ UPDATED EXPORT BUTTON WITH FUNCTIONALITY */}
                    <button 
                        className='d-flex align-items-center justify-content-center gap-2 universal-sec-btn' 
                        disabled={tdsEmpList.length === 0 || isExporting}
                        onClick={() => handleExport('csv')}
                        title={selectedCount > 0 ? `Export ${selectedCount} selected records` : `Export all ${tdsEmpList.length} records`}
                    >
                        {isExporting ? (
                            <>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Exporting...
                            </>
                        ) : (
                            <>
                                <Download /> Export {selectedCount > 0 ? `(${selectedCount})` : ''}
                            </>
                        )}
                    </button>
                </div>
            </div>

            {/* Employee Table */}
            <Widgets
                body={
                    <>
                        <div className="ag-theme-quartz custom-grid mt-2" style={{ height: "calc(100vh - 280px)", width: "100%" }}>
                            {tableLoading ? (
                                <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
                                    <div className="spinner-border text-primary" role="status">
                                        {/* <span className="sr-only"></span> */}
                                        </div>
                                </div>
                            ) : (
                                <AgGridReact
                                    rowHeight={60}
                                    rowData={tdsEmpList}
                                    columnDefs={columnDefs}
                                    pagination={true}
                                    paginationPageSize={paginationPageSize}
                                    paginationPageSizeSelector={paginationPageSizeSelector}
                                    suppressRowClickSelection={true}
                                    onGridReady={onGridReady}
                                    ref={gridRef}
                                    rowSelection="multiple"
                                    onSelectionChanged={onSelectionChanged}
                                />
                            )}
                        </div>
                        {!tableLoading && tdsEmpList.length > 0 && (
                            <div className="d-flex align-items-center justify-content-between custom-pagination">
                                {gridApi && <CustomPagination gridApi={gridApi} />}
                            </div>
                        )}
                    </>
                }
            />

            {/* Dialogs */}
            {staffId && (
                <TdsDialoge
                    staffId={staffId}
                    selectedRows={selectedCount > 0 ? selectedRowsData : null}
                    isApproved={isApproved}
                    closeApproveDialog={closeApproveDialog}
                    isRequestEdit={isRequestEdit}
                    closeRequestEditDialog={closeRequestEditDialog}
                    quickPresets={quickPresets}
                    setQuickPresets={setQuickPresets}
                    isHold={isHold}
                    closeHoldDialog={closeHoldDialog}
                    isRejected={isRejected}
                    closeRejectDialog={closeRejectDialog}
                    onActionComplete={(actionType, updatedStaffIds) => {
                        // This will be called when the dialog action is complete
                        updateLocalEmployeeProofStatus(updatedStaffIds, actionType);
                    }}
                />
            )}

            {/* Recent Activity */}
            <div className="mt-5 mb-5">
                <div className="d-flex align-items-center justify-content-between mb-4">
                    <h3 className="color-white font-weight-200 mb-0">Recent Activity</h3>
                    <Link to="/tds/recent-activity" className="text-purple font-weight-500" style={{ textDecoration: "none" }}>View All</Link>
                </div>

                <div className="setting-border p-0" style={{ borderRadius: "12px", overflow: "hidden" }}>
                    {activityLoading ? (
                        <div className="text-center py-5"><div className="spinner-border text-purple" role="status"><span className="sr-only">Loading...</span></div></div>
                    ) : recentActivity.length === 0 ? (
                        <div className="text-center py-5"><p className="color-gray">No recent activity</p></div>
                    ) : (
                        <div className="d-flex flex-column">
                            {recentActivity.slice(0, 5).map((activity, index) => (
                                <div key={index} className="d-flex align-items-center gap-4 p-4" style={{
                                    background: "rgba(30, 30, 50, 0.8)",
                                    borderBottom: index < 4 ? "1px solid rgba(155, 81, 224, 0.3)" : "none"
                                }}>
                                    <div className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0" style={{
                                        width: "48px", height: "48px",
                                        backgroundColor: activity.status === "approved" ? "rgba(0, 255, 136, 0.2)" :
                                            activity.status === "pending" ? "rgba(255, 215, 0, 0.2)" :
                                                "rgba(255, 68, 68, 0.2)",
                                        border: activity.status === "approved" ? "2px solid #00ff88" :
                                            activity.status === "pending" ? "2px solid #FFD700" :
                                                "2px solid #ff4444"
                                    }}>
                                        {activity.status === "approved" ? <Check style={{ color: "#00ff88", fontSize: "22px" }} /> :
                                            activity.status === "pending" ? <Clock style={{ color: "#FFD700", fontSize: "22px" }} /> :
                                                <Cross style={{ color: "#ff4444", fontSize: "22px" }} />}
                                    </div>
                                    <div className="flex-grow-1">
                                        <p className="color-white font-weight-500 mb-1">
                                            {activity.employeeName}'s TDS form <strong>{activity.action || activity.status}</strong>
                                        </p>
                                        <p className="color-gray font-13">
                                            {activity.performedBy || "System"} • {activity.timeAgo || "Just now"}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Index